export const GET_PROVIDERS = 'CARE.GET_PROVIDERS';
export const GET_PROVIDERS_SUCCESS = 'CARE.GET_PROVIDERS_SUCCESS';
export const GET_PROVIDERS_FAIL = 'CARE.GET_PROVIDERS_FAIL';

export const SELECT_PROVIDER = 'CARE.SELECT_PROVIDER';

export const GET_FORM_INFO = 'CARE.GET_FORM_INFO';
export const GET_FORM_INFO_SUCCESS = 'CARE.GET_FORM_INFO_SUCCESS';
export const GET_FORM_INFO_FAIL = 'CARE.GET_FORM_INFO_FAIL';

export const UPDATE_FORM_INFO = 'CARE.UPDATE_FORM_INFO';
export const SET_ACCEPT_CONNECT_CARE_TC = 'COST.SET_ACCEPT_CONNECT_CARE_TC';

export const GET_CONNECT_CARE_TERMS_AND_CONDITIONS = 'CARE.GET_CONNECT_CARE_TERMS_AND_CONDITIONS';
export const GET_CONNECT_CARE_TERMS_AND_CONDITIONS_SUCCESS =
  'CARE.GET_CONNECT_CARE_TERMS_AND_CONDITIONS_SUCCESS';
export const GET_CONNECT_CARE_TERMS_AND_CONDITIONS_FAIL =
  'CARE.GET_CONNECT_CARE_TERMS_AND_CONDITIONS_FAIL';

export const getProviders = () => ({
  type: GET_PROVIDERS,
  client: 'getCare',
  payload: {
    client: 'getCare',
    request: {
      url: '/getcare/providers'
    }
  }
});

export const selectProvider = (provider: any) => ({
  type: SELECT_PROVIDER,
  payload: provider
});

export const getFormInfo = () => ({
  type: GET_FORM_INFO,
  client: 'getCare',
  payload: {
    client: 'getCare',
    request: {
      url: '/getcare/forminfo'
    }
  }
});

export const updateFormInfo = (updates: any) => ({
  type: UPDATE_FORM_INFO,
  payload: updates
});

export const setAcceptConnectCareTC = () => ({
  type: SET_ACCEPT_CONNECT_CARE_TC
});

export const getConnectCareTermsAndConditions = () => ({
  type: GET_CONNECT_CARE_TERMS_AND_CONDITIONS,
  payload: {
    client: 'cost',
    request: {
      method: 'get',
      // TODO complete when we have endpoint for TsAndCs
      url: ``
    }
  }
});
